import store from '../store'

const onSuccess = (response) => {
  store.dispatch('loader/setLoader', {loading: false, componentKey: null})
  return response
}

const onError = () => {
  store.dispatch('loader/setLoader', {loading: false, componentKey: null})
  // return Promise.reject(error)
}

const beforeRequestSuccess = (request) => {
  let key = null
  if (request && request.componentKey) {
    key = request.componentKey
  }
  !request.params.calledOnce && store.dispatch('loader/setLoader', {loading: true, componentKey: key})
  return
}

const beforeRequestError = (error) => {
  store.dispatch('loader/setLoader', {loading: false, componentKey: null})
  return Promise.reject(error)
}

export { onSuccess, onError, beforeRequestSuccess, beforeRequestError }



// WEBPACK FOOTER //
// ./src/interceptors/loader.js